import './App.css';
import { useState } from "react";
import { Contract, providers } from "ethers";
import NFT from "./abi/gameofthronesNFT.json";
import data from "./json/questions.json";
import ipfsAddress from "./json/ipfsaddress.json";
import HouseDescription from "./components/HouseDescription";
import { Button, Progress, Typography, Alert, Card } from "@material-tailwind/react"

function App() {

  const NFT_CONTRACT_ADDRESS = "0x3894b9e907d03248149fEabc719c7b10C7c03ACa";
  const questions = data.questions;


  const [questionNumber, setQuestionNumber] = useState(0);
  const [houses, setHouses] = useState([]);

  // state for whether app is minting or not.
  const [isMinting, setIsMinting] = useState(false);


  function findHouse() {
    var houseMap = {}
    houses.forEach((house) => {
      if (houseMap[house]) {
        houseMap[house] += 1;
      } else {
        houseMap[house] = 1;
      }
    });
    var maxHouse = "";
    var maxHouseCount = 0;
    for (var house in houseMap) {
      if (houseMap[house] > maxHouseCount) {
        maxHouse = house;
        maxHouseCount = houseMap[house];
      }
    }
    return ipfsAddress[maxHouse];
  }

  async function mint() {
    if (!window.ethereum) {
      alert("Please install metamask");
      return;
    }
    const provider = new providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const NFTContract = new Contract(NFT_CONTRACT_ADDRESS, NFT.abi, signer);

    setIsMinting(true);
    const tokenURI = findHouse()[1];

    try {
      const account = await window.ethereum.request({ method: "eth_requestAccounts", });
      await NFTContract.safeMint(account[0], tokenURI);
      alert("Minted successfully");
    } catch (e) {
      alert("Minting failed");
    } finally {
      setIsMinting(false);
    }
  }

  function QuestionsBlock({ question }) {

    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedID, setSelectedID] = useState(null);

    var answers = question.answers.map((choice, index) => {
      return <Button key={index} onClick={() => { setSelectedOption(choice.house); setSelectedID(index) }} variant={index === selectedID ? "filled" : "text"} className='flex m-3 text-white' color={'brown'} >{choice.answer}</Button>
    });

    return <Card color={'blue-gray'}>
      <div className='w-96 shadow-xl p-3 rounded-lg'>
        <Typography className="text-3xl mb-5 mt-3 font-medium"> <p> Which game of thrones house do you belong to?</p> </Typography>
        <Progress value={(questionNumber / (questions.length - 1)) * 100} color="indigo" className='mr-3' label=" " />
        <div className="grid grid-flow-row m-5">
          <div className='text-2xl'> {question.question} </div>
          <div className="grid grid-flow-row auto-rows-max">{answers}</div>
        </div >
        <Button fullWidth disabled={!selectedOption} onClick={() => { setHouses([...houses, selectedOption]); setQuestionNumber(questionNumber + 1) }} color={questionNumber !== questions.length - 1 ? "amber" : "green"}>{questionNumber !== questions.length - 1 ? "Next" : "Done"}</Button>
      </div>
    </Card>

  }

  return (
    <div className="App flex flex-col items-center m-10">
      {
        questionNumber !== questions.length ?
          <QuestionsBlock question={questions[questionNumber]} /> :
          <>
            <Alert className="mb-10 text-lg" color="green">Minting currently works on the goerli test network, if you want to mint this nft change your ethereum network to goerli.</Alert>
            <HouseDescription mint={mint} findHouse={findHouse} isMinting={isMinting} />
          </>
      }
    </div>
  );

}

export default App;
